<template>
  <div id="app">
    <router-view/>


  </div>
</template>

<script>
    export default {
        name: "App",
        data() {
            return{
                activeIndex: '1',
            }

        },
        methods: {
            handleSelect(key, keyPath) {
                // alert(key, keyPath);
                switch (key.toString()) {
                    case "1":
                        this.$router.push({name: 'indexFirst'});
                        break;
                    case "2":
                        this.$router.push({name: 'about'});
                        break;
                    case 3:
                        break;
                    case 4:
                        break;
                    case 5:
                        break;
                    case 6:
                        break;
                }
            }
        },
        mounted() {

        }
    }
</script>

<style scoped>

  @import "../static/css/rcMain/index_ie.css";
  @import "../static/css/rcMain/common.css";
  .el-menu.el-menu--horizontal{
    border-bottom: none;
  }

/*  #app {*/
/*  font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
/*  -webkit-font-smoothing: antialiased;*/
/*  -moz-osx-font-smoothing: grayscale;*/
/*  text-align: center;*/
/*  color: #2c3e50;*/
/*  margin-top: 60px;*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/App.vue